import PropTypes from 'prop-types';
import styles from './RadioRegister.module.scss';

const RadioRegister = (props) => {
    const { register } = props;
    return (
        <div className={styles.radio}>
            <input
                type="radio"
                id={props.id}
                value={props.value}
                disabled={props?.disabled ? props.disabled : false}
                {...register}
            />
            <label htmlFor={props.id}>{props.label}</label>
        </div>
    );
};

RadioRegister.propsTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    register: PropTypes.object.isRequired,
};

export default RadioRegister;
